document.querySelectorAll('.navi-store img').forEach((image) => {
  image.addEventListener('error', () => {
    image.style.objectFit = 'contain';
    image.style.minHeight = '120px';
    image.style.background = 'var(--color-mint)';
  }, { once: true });
});

// Hidden pages and the draft product cannot render at their future public URLs.
// In an unpublished theme only, point review links at alternate home templates.
// Published-theme visitors use the real product/page URLs in the markup.
const naviParams = new URLSearchParams(window.location.search);
const naviRole = window.Shopify?.theme?.role;
const naviIsPreview = naviRole ? naviRole !== 'main' : naviParams.has('preview_theme_id');
if (naviIsPreview) {
  document.querySelectorAll('[data-navi-preview]').forEach((link) => {
    const destination = new URL(window.Shopify?.routes?.root || '/', window.location.origin);
    destination.searchParams.set('view', link.dataset.naviPreview);
    destination.searchParams.set('preview_theme_id', String(window.Shopify?.theme?.id || naviParams.get('preview_theme_id') || '188440084638'));
    destination.searchParams.set('navi_review', '7');
    link.href = destination.href;
  });
}

const naviImage = document.getElementById('NaviProductImage');
if (naviImage) {
  document.querySelectorAll('.navi-thumb').forEach((button) => {
    button.addEventListener('click', () => {
      naviImage.src = button.dataset.image;
      naviImage.alt = button.dataset.alt;
      document.querySelectorAll('.navi-thumb').forEach((other) => {
        other.setAttribute('aria-pressed', String(other === button));
      });
    });
  });
}

const naviBooks = [...document.querySelectorAll('[data-book-category]')];
document.querySelectorAll('[data-book-filter]').forEach((button) => {
  button.addEventListener('click', () => {
    const filter = button.dataset.bookFilter;
    let count = 0;
    naviBooks.forEach((book) => {
      book.hidden = filter !== 'all' && book.dataset.bookCategory !== filter;
      if (!book.hidden) count++;
    });
    document.querySelectorAll('[data-book-filter]').forEach((other) => {
      other.setAttribute('aria-pressed', String(other === button));
    });
    const status = document.getElementById('NaviBookCount');
    if (status) status.textContent = `${count} ${count === 1 ? 'book' : 'books'} to explore`;
  });
});
document.querySelectorAll('[data-navi-js-control]').forEach((control) => { control.hidden = false; });

document.querySelectorAll('[data-email]').forEach((button) => {
  button.addEventListener('click', async () => {
    const status = document.getElementById('NaviCopyStatus');
    try {
      await navigator.clipboard.writeText(button.dataset.email);
      status.textContent = 'Email address copied. Paste it into your email service.';
    } catch {
      status.textContent = `Please copy the address manually: ${button.dataset.email}`;
    }
  });
});
